import React from 'react'
import { useAtom } from 'jotai'
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { CheckCircle, Pending } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'
import { modalAtom } from '../../common/jotaiState/globalStateAtoms'
import Modal from '../../common/modal'
import { useTranslation } from '../../../i18n/I18nProvider'
const ListItem = ({ item }) => {
	return(
  <TableRow>
    <TableCell sx={{fontSize:"15px"}}>{item.name}</TableCell>
    <TableCell >{item.icon}</TableCell>
  </TableRow>
)}
export default function LoaderModel(props) {
  const { translations } = useTranslation()
  const dm = translations?.deliveryMemo || {}
  const [, setModal] = useAtom(modalAtom)
  const { list } = props
	const theme = useTheme()
	const iconSx = { fontSize: '30px', color: theme.palette.primary.main }

  const statusIconMap = [<Pending sx={iconSx} />, <CircularProgress sx={iconSx} size={30} />, <CheckCircle sx={iconSx} />]
  return (
    <Modal headTxt={dm.loadingDeliveryMemoForAllCities || 'Loading Delivery Memo for All cities'} width={'60%'} updateModal={setModal}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{fontSize:"15px"}}>City Name</TableCell>
            <TableCell sx={{fontSize:"15px"}}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {list.map((item,index) => (
            <ListItem key={"eiss2"+index} item={{...item,icon:statusIconMap[item.loaded]}}/>
          ))}
        </TableBody>
      </Table>
    </Modal>
  )
}
